export interface Formatted<T, G = string> {
  value: T;
  formatted: G;
}

export type NumberFormatted = Formatted<number>;

export type StringFormatted = Formatted<string>;

export interface DateFormatted {
  short: string;
  long: string;
}

export type ChipFormatted = Formatted<ChipType>;

export interface FilterData<T = string> {
  selected: T;
  available: Formatted<T>[];
}

export interface InstrumentImage {
  small: string;
  medium: string;
  large: string;
}

export interface InstrumentTypeFormatted {
  value: InstrumentType;
  formatted: string;
}

export enum InstrumentType {
  Stock = 'Stock',
  FII = 'FII',
  ETF = 'ETF',
  BDR = 'BDR',
  Crypto = 'Crypto',
  BrazilianAssets = 'brazilianAssets',
  GlobalAssets = 'globalAssets',
  RealStateAssets = 'realStateAssets',
  All = 'All'
}

export interface PaginationData {
  page: number;
  itemsPerPage: number;
  totalPages: number;
  hasMore: boolean;
}

export interface BFFErrorResponse {
  error: {
    code: number;
    message: {
      value: string;
      formatted: string;
    };
  };
}

export enum ChipType {
  positive = 'positive',
  negative = 'negative',
  alert = 'alert',
  information = 'information'
}
